enum ENUM_USER_ROLE {
  ADMIN = "admin",
  AMBASSADOR = "ambassador",
  VENDOR = "vendor",
  OPPORTUNITY_VENDOR = "opportunity-vendor",
  DELEGATE_VENDOR = "delegate-vendor",
}

enum ENUM_NOTIFICATION_TYPES {
  NEW_PROJECT = "new-project",
  MEETING_BOOKED = "meeting_booked",
  MEETING_REQUESTED = "meeting_requested",
  MEETING_RESCHEDULE = "meeting_reschedule",
  BEFORE_24_HOURS_OF_MEETING = "before_24_hours_of_meeting",
  BEFORE_1_HOUR_OF_MEETING = "before_1_hour_of_meeting",
  BEFORE_15_MINUTES_OF_MEETING = "before_15_minutes_of_meeting",
}

export { ENUM_USER_ROLE, ENUM_NOTIFICATION_TYPES };
